<nb-card>
  <nb-card-header>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="{{ 'common.strSearch' | translate }}"
          [(ngModel)]="strSearch"
        />
      </nb-form-field>
    </div>
  </nb-card-header>
  <nb-card-body>
    <nb-list>
      <nb-list-item
        *ngFor="let item of receipts | filter: strSearch; let i = index"
        [ngClass]="i % 2 == 0 ? 'content bg1' : 'content bg2'"
      >
        <div>
          <div class="content">
            <div>
              <nb-icon icon="calendar-outline"></nb-icon>
              <span class="link text-hint">
                {{ item.issueDate | date: "dd/MM/yyyy HH:mm" }}</span
              >
            </div>

            <div class="customer-info">
              <h6 class="link text-body">
                {{ item.customerName }}
                <span *ngIf="item.customerMobile" class="link text-hint">
                  - {{ item.customerMobile }}
                </span>
              </h6>
            </div>

            <div>
              <a
                *ngIf="!item.isMore"
                (click)="loadContent(true, item)"
                class="link text-link"
              >
                <nb-icon icon="chevron-down-outline"></nb-icon>
                Xem thêm...
              </a>

              <a
                *ngIf="item.isMore"
                (click)="loadContent(false, item)"
                class="link text-link"
              >
                <nb-icon icon="chevron-up-outline"></nb-icon>
                Thu gọn
              </a>
            </div>
          </div>
          <div *ngIf="item.isMore" class="detail">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead class="thead-light">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Tên hàng</th>
                    <th scope="col">ĐVT</th>
                    <th scope="col" class="col-number">Đơn giá</th>
                    <th scope="col" class="col-number">Số lượng</th>
                    <th scope="col" class="col-number">$ giảm</th>
                    <th scope="col" class="col-number">Thành tiền</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let itemDetail of item.receiptDetails;
                      let i = index
                    "
                  >
                    <td class="col-no">
                      {{ i + 1 }}
                    </td>
                    <td>
                      {{ itemDetail.productName }}
                    </td>
                    <td>
                      {{ itemDetail.productUnitName }}
                    </td>
                    <td class="col-number">
                      {{ itemDetail.price | number }}
                    </td>
                    <td class="col-number">
                      {{ itemDetail.quantity | number }}
                    </td>
                    <td class="col-number">
                      {{ itemDetail.discountAmount | number }}
                    </td>
                    <td class="col-number">
                      <strong>{{ itemDetail.amount | number }}</strong>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td class="col-label" colspan="4">
                      <strong class="text-hint">Tổng cộng</strong>
                    </td>
                    <td class="col-number">
                      <strong class="text-primary">
                        {{ item.totalQuantity | number }}
                      </strong>
                    </td>
                    <td></td>
                    <td class="col-number">
                      <strong class="text-primary">
                        {{ item.detailAmount | number }}
                      </strong>
                    </td>
                  </tr>

                  <tr *ngIf="item.discountAmount > 0">
                    <td class="col-label" colspan="4">
                      <strong class="text-hint">Chiết khấu</strong>
                    </td>
                    <td colspan="3" class="col-number">
                      <strong class="text-primary">
                        {{ item.discountAmount | number }}
                      </strong>
                    </td>
                  </tr>

                  <tr *ngIf="item.totalAmount !== item.detailAmount">
                    <td class="col-label" colspan="4">
                      <strong class="text-hint">Thành tiền</strong>
                    </td>
                    <td colspan="3" class="col-number">
                      <strong class="text-primary">
                        {{ item.totalAmount | number }}
                      </strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <button
          nbButton
          shape="round"
          outline
          status="success"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="selected(item)"
        >
          <nb-icon icon="checkmark-outline"></nb-icon>
        </button>
      </nb-list-item>
    </nb-list>
  </nb-card-body>

  <nb-card-footer>
    <button
      nbButton
      shape="semi-round"
      outline
      status="danger"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
      <span>{{ "buttons.close" | translate }}</span>
    </button>
  </nb-card-footer>
</nb-card>
